
import * as React from "react";

import { SvgIconProps } from "@material-ui/core/SvgIcon";

import AccessibilityIcon from "@material-ui/icons/Accessibility";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AddIcon from "@material-ui/icons/Add";
import AppsIcon from "@material-ui/icons/Apps";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import AspectRationCircleIcon from "@material-ui/icons/AspectRatioOutlined";

import BubbleChart from "@material-ui/icons/BubbleChartOutlined";
import BugReportIcon from "@material-ui/icons/BugReport";

import CallIcon from "@material-ui/icons/Call";
import CallEndIcon from "@material-ui/icons/CallEnd";
import CameraIcon from "@material-ui/icons/Camera"
import ChatIcon from "@material-ui/icons/Chat";
import CheckIcon from "@material-ui/icons/Check";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ClearIcon from "@material-ui/icons/Clear";
import CloseIcon from "@material-ui/icons/Close";
import CloudIcon from "@material-ui/icons/Cloud";
import CodeIcon from "@material-ui/icons/Code";
import CreateIcon from "@material-ui/icons/Create";

import DashboardIcon from "@material-ui/icons/Dashboard";
import DateRangeIcon from "@material-ui/icons/DateRange";
import DeleteIcon from "@material-ui/icons/Delete";
import DocumentIcon from "@material-ui/icons/Description";

import EmailIcon from "@material-ui/icons/Email";
import EmailOutlineIcon from "@material-ui/icons/EmailOutlined";
import FeedbackIcon from "@material-ui/icons/FeedbackOutlined";
import FilterListIcon from "@material-ui/icons/FilterList";

import FullscreenExitIcon from "@material-ui/icons/FullscreenExitOutlined";
import FullscreenIcon from "@material-ui/icons/FullscreenOutlined";

import SupportIcon from "@material-ui/icons/ContactSupportOutlined";
import HelpIcon from "@material-ui/icons/HelpOutline";
import HomeIcon from "@material-ui/icons/Home";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooksOutlined";
import HelpLiveIcon from "@material-ui/icons/LiveHelpOutlined";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import LockIcon from "@material-ui/icons/LockOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import MobileIcon from "@material-ui/icons/MobileFriendly";
import MobileOutlineIcon from "@material-ui/icons/MobileFriendlyOutlined";
import NoteIcon from "@material-ui/icons/Comment";
import NotificationsIcon from "@material-ui/icons/Notifications";
import PeopleIcon from "@material-ui/icons/People";
import PersonAdd from "@material-ui/icons/PersonAddOutlined";
import PhotoCamera from "@material-ui/icons/PhotoCamera"
import PrintIcon from "@material-ui/icons/Print";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import SmileyIcon from "@material-ui/icons/SentimentSatisfiedAltOutlined";
import SettingsIcon from "@material-ui/icons/Settings";
import LogoutIcon from "@material-ui/icons/SettingsPower";
import SmsIcon from "@material-ui/icons/SmsOutlined";
import FavoriteIcon from "@material-ui/icons/Star";
import UnfavoriteIcon from "@material-ui/icons/StarBorder";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import UnlockIcon from "@material-ui/icons/LockOpen";
import StoreIcon from "@material-ui/icons/Store";
import UpdateIcon from "@material-ui/icons/UpdateOutlined";
import WarningIcon from "@material-ui/icons/Warning";
import WebIcon from "@material-ui/icons/Web";
import WorkIcon from "@material-ui/icons/Work";

import ZoomOutIcon from "@material-ui/icons/ZoomOutMapOutlined";

import GroupWorkIcon from "@material-ui/icons/GroupWork";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";


import { AppIconType } from "./AppIconType";

export interface IAppIconProps  {
    icon: AppIconType;
}

class AppIcon extends React.Component<IAppIconProps & SvgIconProps> {

    public render() {
        switch (this.props.icon) {
            case AppIconType.Accessibility:
                return ( <AccessibilityIcon {...this.props}  /> );
            case AppIconType.AccessTime:
                return ( <AccessTimeIcon {...this.props} /> );
            case AppIconType.Account:
                return ( <AccountCircleIcon {...this.props} /> );
            case AppIconType.Add:
                return ( <AddIcon {...this.props} /> );
            case AppIconType.Applicatons:
                return ( <AppsIcon {...this.props} /> );
            case AppIconType.AspectRatio:
                return ( <AspectRationCircleIcon {...this.props} /> );
            case AppIconType.Back:
                return (<ArrowBackIcon {...this.props} />);
            case AppIconType.BusinessUnit:
                return (<AccountBalanceIcon {...this.props} />);
            case AppIconType.BubbleChart:
                return (<BubbleChart {...this.props} />);
            case AppIconType.ArrowUp:
                return ( <ArrowUpwardIcon {...this.props} /> );
            case AppIconType.Bug:
                return ( <BugReportIcon {...this.props} /> );
            case AppIconType.Call:
                return ( <CallIcon {...this.props} />);
            case AppIconType.CallEnd:
                return ( <CallEndIcon {...this.props} />);
            case AppIconType.Camera:
                return ( <PhotoCamera {...this.props} />);
            case AppIconType.Create:
                return ( <CreateIcon {...this.props} /> );
            case AppIconType.Code:
                return ( <CodeIcon {...this.props} /> );
            case AppIconType.Chat:
                return ( <ChatIcon {...this.props} /> );
            case AppIconType.Check:
                return ( <CheckIcon {...this.props} /> );
            case AppIconType.Clear:
                return ( <ClearIcon {...this.props} /> );
            case AppIconType.Close:
                return <CloseIcon {...this.props} /> ;
            case AppIconType.Cloud:
                return ( <CloudIcon {...this.props} /> );
            case AppIconType.ChevronLeft:
                return ( <ChevronLeftIcon {...this.props} /> );
            case AppIconType.DateRange:
                return ( <DateRangeIcon {...this.props} /> );
            case AppIconType.Dashboard:
                return ( <DashboardIcon {...this.props} /> );
            case AppIconType.Delete:
                return ( <DeleteIcon {...this.props} /> );
            case AppIconType.Documents:
                return ( <DocumentIcon {...this.props} /> );
            case AppIconType.Email:
                return ( <EmailIcon {...this.props} /> );
            case AppIconType.EmailOutline:
                return ( <EmailOutlineIcon {...this.props} /> );
            case AppIconType.Favorite:
                return ( <FavoriteIcon {...this.props} /> );
            case AppIconType.FilterList:
                return ( <FilterListIcon {...this.props} /> );
            case AppIconType.Finished:
                return ( <CheckCircle {...this.props} /> );
            case AppIconType.Fullscreen:
                return <FullscreenIcon {...this.props} />;
            case AppIconType.FullscreenExit:
                return <FullscreenExitIcon {...this.props} />;
            case AppIconType.Feedback:
                return ( <FeedbackIcon {...this.props}  /> );
            case AppIconType.GroupWork:
                return ( <GroupWorkIcon {...this.props} /> );
            case AppIconType.Help:
                return ( <HelpIcon {...this.props} /> );
            case AppIconType.HelpLive:
                return ( <HelpLiveIcon {...this.props} /> );
            case AppIconType.Home:
                return ( <HomeIcon {...this.props} /> );
            case AppIconType.InfoOutline:
                return ( <InfoOutlinedIcon {...this.props} /> );
            case AppIconType.LibraryBooks:
                return ( <LibraryBooksIcon {...this.props} /> );
            case AppIconType.Mobile:
                return ( <MobileIcon {...this.props} /> );
            case AppIconType.MobileOutline:
                return ( <MobileOutlineIcon {...this.props} /> );
            case AppIconType.Note:
                return ( <NoteIcon {...this.props} /> );
            case AppIconType.LocalOffer:
                return ( <LocalOfferIcon {...this.props} /> );
            case AppIconType.Lock:
                return ( <LockIcon {...this.props} /> );
            case AppIconType.Logout:
                return ( <LogoutIcon {...this.props} /> );
            case AppIconType.Menu:
                return ( <MenuIcon {...this.props} /> );
            case AppIconType.Notifications:
                return ( <NotificationsIcon {...this.props} /> );
            case AppIconType.People:
                return ( <PeopleIcon {...this.props} /> );
            case AppIconType.PersonAdd:
                return ( <PersonAdd {...this.props} /> );
            case AppIconType.Print:
                return ( <PrintIcon {...this.props} /> );
            case AppIconType.Save:
                return ( <SaveIcon {...this.props} /> );
            case AppIconType.Search:
                return ( <SearchIcon {...this.props} /> );
            case AppIconType.Settings:
                return ( <SettingsIcon {...this.props} /> );
            case AppIconType.Snapshot:
                return ( <CameraIcon {...this.props} />);
            case AppIconType.Smiley:
                return ( <SmileyIcon {...this.props} /> );
            case AppIconType.Sms:
                return ( <SmsIcon {...this.props} /> );
            case AppIconType.Support:
                return ( <SupportIcon {...this.props} /> );
            case AppIconType.Store:
                return ( <StoreIcon {...this.props} /> );
            case AppIconType.ThumbDown:
                return ( <ThumbDownIcon {...this.props} /> );
            case AppIconType.ThumbUp:
                return ( <ThumbUpIcon {...this.props} /> );
            case AppIconType.Unfavorite:
                return ( <UnfavoriteIcon {...this.props} /> );
            case AppIconType.Unlock:
                return ( <UnlockIcon {...this.props} /> );
            case AppIconType.Update:
                return ( <UpdateIcon {...this.props} /> );
            case AppIconType.VisibilityOff:
                return ( <VisibilityOffIcon {...this.props} /> );
            case AppIconType.VisibilityOn:
                return ( <VisibilityIcon {...this.props} /> );
            case AppIconType.Warning:
                return ( <WarningIcon {...this.props} /> );
            case AppIconType.Web:
                return ( <WebIcon {...this.props} /> );
            case AppIconType.Work:
                return ( <WorkIcon {...this.props} /> );
            case AppIconType.ZoomOut:
                return ( <ZoomOutIcon {...this.props} /> );
            default:
                throw new Error("Unsupported icon:" + this.props.icon);
        }
    }
}

export default AppIcon;
